import { Box, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useRegisterBrand } from '../../hooks/useRegisterBrand'
import { getRegisterBrandFormValues } from '../../utils/getRegisterBrandFormValues'
import { registerBrandFormValidationSchema } from '../../validation/registerBrandForm'
import { BigPaper } from '../BigPaper/BigPaper'
import { Form } from '../Form'
import { PrimaryButton } from '../PrimaryButton'
import { BrandDataFields } from './BrandDataFields'
import { CampaignFields } from './CampaignFields'
import { ContactFields } from './ContactFields'
import { Success } from './Success'
import { TimelineAndBudgetFields } from './TimelineAndBudgetFields'

export const RegisterBrandForm = () => {
  const { mutate: register, isLoading, isSuccess } = useRegisterBrand()
  const handleSubmit = async (args, { setError }) => {
    await register(getRegisterBrandFormValues(args), {
      onError: error => {
        let key = '',
          message = ''
        if (
          error &&
          error.message &&
          error.message.keys &&
          error.message.keys.keyPattern
        ) {
          key = Object.keys(error.message.keys.keyPattern)[0]
        }
        if (error && error.message) {
          message = error.message.errorMessage
        }

        if (message === 'Duplicate Campaign Entry') {
          setError(
            'campaign.name',
            {
              type: 'focus',
              message: 'Campaign already exists'
            },
            { shouldFocus: true }
          )
        }

        if (key === 'username') {
          const fieldName = 'contact.email'
          setError(
            fieldName,
            {
              type: 'focus',
              message: 'Email already exists'
            },
            { shouldFocus: true }
          )
        }
      }
    })
  }

  const theme = useTheme()

  if (isSuccess) {
    return <Success />
  }

  return (
    <Form
      onSubmit={handleSubmit}
      validationSchema={registerBrandFormValidationSchema}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <BigPaper
            elevation={0}
            style={{
              backgroundColor: theme.palette.buzzin.main,
              padding: '40px 32px'
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography
                  variant='h5'
                  style={{
                    color: '#fff',
                    fontWeight: '800',
                    fontSize: '36px'
                  }}
                  align='center'
                >
                  Start a Campaign
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <BrandDataFields />
              </Grid>
              <Grid item xs={12}>
                <ContactFields />
              </Grid>
              <Grid item xs={12}>
                <CampaignFields showTitle />
              </Grid>
              <Grid item xs={12}>
                <TimelineAndBudgetFields />
              </Grid>
            </Grid>
          </BigPaper>
        </Grid>
        <Grid item xs={12}>
          <Box paddingRight={3} display='flex' justifyContent='flex-end'>
            <PrimaryButton type='submit' disabled={isLoading}>
              Submit
            </PrimaryButton>
          </Box>
        </Grid>
      </Grid>
    </Form>
  )
}
